<div class="content">
  @for (answer of data.openQuestionAnswers; track answer.id) {
    <rt-candidate-questions-item
      [canManageCandidates]="canManageCandidates"
      [data]="$any(answer)"
      [visibilityTplRef]="visibilityTplRef"
      [hasBooleanFlagAnswers]="hasBooleanFlagAnswers"
    ></rt-candidate-questions-item>
  }
</div>
